// extracted by mini-css-extract-plugin
export default {"updateAppBanner":"app_updateAppBanner__t7kuc","stripes-animation-background-keyframes":"app_stripes-animation-background-keyframes__g9heQ"};